
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/lodging",
      function () {
        return require("private-next-pages/[region]/[resort]/lodging.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/lodging"])
      });
    }
  